import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent, type Analytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyAaR2jPtzS1Oby7tkAanCxgHA0HLiUxeKc',
  authDomain: 'looksmaxxing-b6fec.firebaseapp.com',
  projectId: 'looksmaxxing-b6fec',
  storageBucket: 'looksmaxxing-b6fec.firebasestorage.app',
  messagingSenderId: '1010424696469',
  appId: '1:1010424696469:web:c4abff4e1be6b39495d59c',
  measurementId: 'G-D6VWWRQ78B',
};

let analyticsInstance: Analytics | null = null;
const ROUTE_EVENT_MAP: Record<string, string> = {
  '/onboarding/rating-type': 'onboarding_1',
  '/onboarding/gender': 'onboarding_2',
  '/onboarding/age': 'onboarding_3',
  '/onboarding/focus': 'onboarding_4',
  '/onboarding/self-rating': 'onboarding_5',
  '/onboarding/mission': 'onboarding_6',
  '/onboarding/improve-more': 'onboarding_7',
  '/onboarding/appearance-anxiety': 'onboarding_8',
  '/onboarding/motivation': 'onboarding_9',
  '/onboarding/science': 'onboarding_10',
  '/onboarding/compliments': 'onboarding_11',
  '/onboarding/week1': 'onboarding_12',
  '/onboarding/week10': 'onboarding_13',
  '/onboarding/comparison': 'onboarding_14',
  '/onboarding/trajectory': 'onboarding_15',
  '/onboarding/lockin': 'onboarding_16',
  '/onboarding/hype': 'onboarding_17',
  '/paywall': 'paywall_view',
  '/rating/front': 'rating_front_view',
  '/rating/side': 'rating_side_view',
  '/rating/analyzing': 'rating_analyzing_view',
  '/results/history': 'results_history_view',
  '/results/view': 'results_view',
};

export const initAnalytics = () => {
  if (analyticsInstance || typeof window === 'undefined') return analyticsInstance;
  const app = initializeApp(firebaseConfig);
  analyticsInstance = getAnalytics(app);
  return analyticsInstance;
};

export const trackEvent = (name: string, params?: Record<string, unknown>) => {
  const analytics = initAnalytics();
  if (!analytics) return;
  logEvent(analytics, name as string, params);
};

export const trackRouteView = (pathname: string) => {
  const eventName = ROUTE_EVENT_MAP[pathname];
  if (!eventName) return;
  trackEvent(eventName, { path: pathname });
};
